import { render, staticRenderFns } from "./orderFilter.vue?vue&type=template&id=2b34dff0&scoped=true&"
import script from "./orderFilter.vue?vue&type=script&lang=js&"
export * from "./orderFilter.vue?vue&type=script&lang=js&"
import style0 from "./orderFilter.vue?vue&type=style&index=0&id=2b34dff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b34dff0",
  null
  
)

export default component.exports